// jshint esversion: 8

import { set, toggle } from '@/utils/vuex';

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  SET_TEMP: (state, payload) => state.temp = payload,
  ADD_NOTIFICATION: (state, payload) => state.notifications.push(payload),
  REMOVE_NOTIFICATION: (state, index) => state.notifications.splice(index),
  SET_ERROR: (state, payload) => state.error = payload,
  PUSH_ERROR: (state, payload) => state.error.push(payload),
  TOGGLE_LOADING: state => state.loading = !state.loading,
  UPDATE_PROGRESS: (state, payload) => state.progress = payload * 100,
  SET_TOKEN_EXPIRATION: (state, payload) => state.tokenExpire = payload
};
